import { CommentaryEntityContext } from '@helios/common-api'
import { MandatoryFields } from '@helios/server-side-util'

/**
 * `fields` is the grid's always-loaded field list for commentary — feed it to
 * the `mandatoryFields` argument of `toHeliosRequest` via `mandatoryFields()`
 * so the links a thread carries depend on the row rather than on which columns
 * the user has visible.
 */
export interface CommentaryRowContext<
  T,
  K extends keyof T & string = keyof T & string,
> {
  readonly fields: readonly K[]
  build(row: Pick<T, K>): CommentaryEntityContext
  mandatoryFields(...additional: string[]): MandatoryFields
}

export function declareCommentaryContext<T>() {
  return <K extends keyof T & string>(declaration: {
    fields: readonly K[]
    build: (row: Pick<T, K>) => CommentaryEntityContext
  }): CommentaryRowContext<T, K> => ({
    fields: declaration.fields,
    build: declaration.build,
    mandatoryFields: (...additional) =>
      [...declaration.fields, ...additional] as unknown as MandatoryFields,
  })
}
